import axios from 'axios'
import { CONFIGS } from '../configs'

export default {
  create(data) {
    return axios.post(CONFIGS.API_SERVER + '/api/contact/', data)
  }
}
